import roundedLogo from '../../../../common/assets/images/img_blue_fish.png';
import { Button, List } from 'antd';
import SvgPadlock from '../../../assets/images/padlock';
import React from 'react';

export default function SBPlusAdvertCard({ subscribed = false }) {
  return (
    <div
        className={'br20 grey-bg-900 white txt-center overflow-hidden'}
        id={'plus-banner'}
      >
        <div className='uppercase gBold fs-21 pd-10 grey-100 sb-blue-bg-500'>
          Welcome back!
        </div>
        <div className={'pd-20 pd-top-30 pd-bottom-30'}>
          <h2 className='font-montserrat white fs-30 mg-bottom-5 pd-bottom-8 mg-top-0 fs-18'>
            {subscribed ? 'PRO Member' : 'Want more?'}
          </h2>
          {subscribed && (
            <p className='gMedium fs-16'>
              Thanks for being a valued subscriber!
            </p>
          )}
          <div className='gSemiBold fs-16'>
            <List
              bordered={false}
              className='w-fit mg-auto-lr'
              size='small'
              dataSource={
                subscribed
                  ? [
                    'Don\'t forget to enter the giveaways!',
                    'You are covered in case of accidents or damage to equipment!',
                    'Keep an eye on the perks section!',
                  ]
                  : [
                    'Advanced Catch Report Data',
                    'Comprehensive Angling Insurance',
                    'Unique Products + Weekly Giveaways',
                    'Cashback On Every Booking!',
                  ]
              }
              renderItem={(item) => (
                <List.Item
                  className={
                    'gSemiBold fs-17 txt-left pd-top-5 pd-bottom-10 white'
                  }
                  style={{ borderBottom: 'none' }}
                >
                  <SvgPadlock className='seagreen-200 mg-right-5' /> {item}
                </List.Item>
              )}
            />
            {!subscribed && (
              <p className={'pd-top-8 gLight fs-16 mg-bottom-0'}>
                and much more...
              </p>
            )}
            <Button
              href={
                !subscribed
                  ? `${process.env.REACT_APP_SBPLUS_URL}/sign-up`
                  : '/user/profile'
              }
              target={'_blank'}
              className='sb-blue-gradient-bg-right border-1 sb-blue-border-300 mg-top-30 white gSemiBold brFull fs-18 txt-center w-full max-w-300 pd-10 h-fit txt-wrap antd-link-button-override'
            >
              {subscribed ? 'View MySB+' : 'Learn More'}
            </Button>
          </div>
        </div>
      </div>
  );
}